<template>
    <div class="location">
        <div class="row align-items-center title-row" :class="{ 'no-damages': ( location.damages.length === 0 ) }">
            <div class="col-12">
                <h3>{{ location.location.location }}</h3>
                <p v-if="location.location.limited_by">{{ location.location.limited_by | formatLimitedBy }}</p>
            </div>

            <div class="col-12" v-if="location.location.images.length > 0">
                <div class="damage">
                    <h4>Overzichtsfoto's</h4>

                    <ul class="gallery">
                        <li v-for="(image, index) in getStructuredImages" :key="image.id"><img :src="image.thumb" :alt="image.caption" @click="openLightbox( index )"></li>
                    </ul>

                    <LightBox :images="getStructuredImages" ref="lightbox" :show-caption="true" :show-light-box="false"/>
                </div>
            </div>
        </div>

        <template v-if="location.damages.length > 0">
            <hr>

            <div class="row">
                <div class="col-12">
                    <Damage v-for="damage in location.damages" :damage="damage" :key="damage.id"/>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Damage from '@/components/online-dossier/Damage'
    import LightBox from 'vue-image-lightbox'

    require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

    export default {
        components: { Damage, LightBox },

        props: ['location'],

        computed: {
            getStructuredImages () {
                return this.location.location.images.map((image) => {
                    return {
                        id: image.id,
                        thumb: image.paths['hd-thumb'],
                        src: image.paths.hd,
                        caption: image.name,
                    }
                })
            },
        },

        methods: {
            openLightbox (index) {
                this.$refs.lightbox.showImage(index)
            },
        }
    }
</script>